import request from "@/axios.js";

export class Service {
	/**
	 * Service class
	 * @property {Number} id - id of the service
	 * @property {string} name - a name for the service.
	 */
	constructor(service) {
		this.name = service.name;
	}

	/**
	 * Returns a list of all services
	 * @return {List} list of all services
	 */
	static getAllServices(callback) {
		request
			.get("service/all")
			.then(result => {
				callback(null, result.data);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	/**
	 * Create a service
	 * @param {Service} service - service to create
	 */
	createService(callback) {
		let param = {
			name: this.name,
		};
		request
			.post("service/add", param)
			.then(result => {
				callback(null, result);
			})
			.catch(err => callback(err, null));
	}
}
